// Mock data for Anaé Vilnor Photography Portfolio

export const siteInfo = {
  name: "Anaé Vilnor",
  tagline: "Fine Art Photography",
  subtitle: "Editorial · Portrait · Artistic Expression",
  email: "contact@anaevilnor.com",
  phone: "+33 6 12 34 56 78",
  location: "Paris, France",
  instagram: "https://instagram.com/anaevilnor",
  behance: "https://behance.net/anaevilnor"
};

export const heroImage = "https://images.unsplash.com/photo-1617119552150-ecc899f6562c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxibGFjayUyMHdoaXRlJTIwZWRpdG9yaWFsJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzcwNTI1NDMzfDA&ixlib=rb-4.1.0&q=85";

export const aboutImage = "https://images.unsplash.com/photo-1665076142905-6ead3e2717e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxmaW5lJTIwYXJ0JTIwcG9ydHJhaXR8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzcwNTI1NDM5fDA&ixlib=rb-4.1.0&q=85";

export const portfolioCollections = [
  {
    id: "editorial",
    title: "Editorial",
    description: "Fashion & Magazine Work",
    images: [
      {
        id: 1,
        src: "https://images.unsplash.com/photo-1552393700-42696fb89bfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwZmFzaGlvbnxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzA1MjU0NDN8MA&ixlib=rb-4.1.0&q=85",
        title: "Vogue Paris",
        year: "2024"
      },
      {
        id: 2,
        src: "https://images.unsplash.com/photo-1552394211-1f9c6b916c09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxtaW5pbWFsJTIwZmFzaGlvbnxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzA1MjU0NDN8MA&ixlib=rb-4.1.0&q=85",
        title: "Harper's Bazaar",
        year: "2024"
      },
      {
        id: 3,
        src: "https://images.unsplash.com/photo-1609565910144-63e045db453a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxtaW5pbWFsJTIwZmFzaGlvbnxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzA1MjU0NDN8MA&ixlib=rb-4.1.0&q=85",
        title: "Elle Magazine",
        year: "2023"
      }
    ]
  },
  {
    id: "portraits",
    title: "Portraits",
    description: "Artistic Portraiture",
    images: [
      {
        id: 4,
        src: "https://images.unsplash.com/photo-1711928340249-ca478595b91e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxmaW5lJTIwYXJ0JTIwcG9ydHJhaXR8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzcwNTI1NDM5fDA&ixlib=rb-4.1.0&q=85",
        title: "Silence Intérieur",
        year: "2024"
      },
      {
        id: 5,
        src: "https://images.unsplash.com/photo-1665076809379-176735b7fe73?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxmaW5lJTIwYXJ0JTIwcG9ydHJhaXR8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzcwNTI1NDM5fDA&ixlib=rb-4.1.0&q=85",
        title: "L'Attente",
        year: "2024"
      },
      {
        id: 6,
        src: "https://images.unsplash.com/photo-1652281846249-fd131a6cca36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxibGFjayUyMHdoaXRlJTIwZWRpdG9yaWFsJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzcwNTI1NDMzfDA&ixlib=rb-4.1.0&q=85",
        title: "Réflexion",
        year: "2023"
      }
    ]
  },
  {
    id: "minimal-art",
    title: "Minimal Art",
    description: "Abstract & Conceptual",
    images: [
      {
        id: 7,
        src: "https://images.unsplash.com/photo-1718123793344-060675cd9eef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxibGFjayUyMHdoaXRlJTIwZWRpdG9yaWFsJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzcwNTI1NDMzfDA&ixlib=rb-4.1.0&q=85",
        title: "Géométrie du Vide",
        year: "2024"
      },
      {
        id: 8,
        src: "https://images.unsplash.com/photo-1617119552126-82eea684d9c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxibGFjayUyMHdoaXRlJTIwZWRpdG9yaWFsJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzcwNTI1NDMzfDA&ixlib=rb-4.1.0&q=85",
        title: "Lumière & Ombre",
        year: "2024"
      },
      {
        id: 9,
        src: "https://images.unsplash.com/photo-1609565911206-04527a94436e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwZmFzaGlvbnxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzA1MjU0NDN8MA&ixlib=rb-4.1.0&q=85",
        title: "Essence",
        year: "2023"
      }
    ]
  }
];

export const services = [
  {
    id: 1,
    title: "Shooting Éditorial",
    description: "Collaborations avec magazines, marques de mode et publications internationales. Direction artistique complète du concept à la livraison finale.",
    features: ["Direction artistique", "Retouche haut de gamme", "Livraison haute résolution"]
  },
  {
    id: 2,
    title: "Portrait Artistique",
    description: "Sessions individuelles pour capturer l'essence de chaque sujet. Une approche intimiste et personnalisée.",
    features: ["Consultation préalable", "Séance en studio ou extérieur", "Tirage Fine Art disponible"]
  },
  {
    id: 3,
    title: "Direction Artistique",
    description: "Conception de moodboards, direction créative pour campagnes et projets spéciaux. Vision artistique unique.",
    features: ["Moodboards personnalisés", "Casting & styling", "Post-production créative"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Élise Marchand",
    role: "Directrice Artistique, Vogue Paris",
    text: "Anaé possède une sensibilité rare. Chaque image qu'elle crée raconte une histoire silencieuse mais profondément émouvante."
  },
  {
    id: 2,
    name: "Thomas Lefèvre",
    role: "Fondateur, Galerie L'Instant",
    text: "Son travail transcende la photographie traditionnelle. C'est de l'art pur, capturé dans la lumière."
  },
  {
    id: 3,
    name: "Sophie Delacroix",
    role: "Mannequin International",
    text: "Travailler avec Anaé est une expérience unique. Elle capture l'invisible, ce que nous ne savons même pas que nous portons en nous."
  }
];

export const aboutContent = {
  quote: "Je photographie les silences que les mots ne savent pas tenir.",
  bio: "Photographe basée à Paris, je crée depuis plus de dix ans des images qui explorent la frontière entre le visible et l'invisible. Mon travail puise dans le minimalisme, la lumière naturelle et l'émotion brute.",
  approach: "Ma démarche artistique s'ancre dans l'observation patiente. Je cherche ces instants suspendus où le temps semble retenir son souffle — ces moments de grâce imperceptible que seul l'objectif peut capturer.",
  influences: ["Richard Avedon", "Peter Lindbergh", "Irving Penn", "Helmut Newton"]
};
